import CardProduto, { Produto } from "../CardProduto/CardProduto";
import styles from "./Promocao.module.css";
import { useEffect, useState } from "react";
import api from "../../utils/axios/api";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function ProdutosEmPromocao() {
  const [produtosPromocao, setProdutosPromocao] = useState<Produto[]>([]);

  useEffect(() => {
    async function LoadProducts() {
      const response = await api.get(`/product?filter=promocoes`);
      const produtosLimitados = Array.isArray(response.data)
        ? response.data.slice(0, 24)    // limita a 24 se for array
        : [];
      setProdutosPromocao(produtosLimitados);
    }
    LoadProducts();
  }, []);

  return (
    <div className={styles.produtosPromocaoContainer}>
      <Swiper
        spaceBetween={50}
        style={{ padding: "8px 20px" }}
        grabCursor={true}
        breakpoints={{
          320: { slidesPerView: 2.5 },
          640: { slidesPerView: 3.5 },
          768: { slidesPerView: 4.5 },
          1024: { slidesPerView: 5.5 },
          1200: { slidesPerView: 6.5 },
        }}
      >
        <div className={styles.produtosPromocaoLista}>
          {Array.isArray(produtosPromocao)
            ? produtosPromocao.map((produto) => (
                <SwiperSlide key={produto.id}>
                  <CardProduto produto={produto} />
                </SwiperSlide>
              ))
            : null}
        </div>
      </Swiper>
    </div>
  );
}

export default ProdutosEmPromocao;
